export type Tema = 'claro' | 'escuro';

export const TEMA_PADRAO: Tema = 'claro';
export const CLASSE_TEMA_ESCURO = 'tema-escuro';

export const ehTemaValido = (valor: unknown): valor is Tema => valor === 'claro' || valor === 'escuro';
